<template>
  <div class="header-cart-view">
    <v-btn
      v-if="validateIconCart"
      x-small fab color="cluvi2"
      :icon="is_ontable_mylist? false:true"
      @click.stop="goToCart()" class="pay-btn"
    >
      <v-icon v-if="!showBadge" medium color="white">{{ icon }}</v-icon>
      <v-badge
        v-else
        :bottom="is_ontable_mylist?true:false"
        :overlap="is_ontable_mylist?true:false"
        :bordered="is_ontable_mylist?true:false"
        transition="slide-x-transition"
        :content="countBadge"
      >
        <v-icon medium color="white">{{ icon }}</v-icon>
      </v-badge>
      <div v-if="showTooltip" class="tooltip">
        <span>{{ $t('menu-digital.no_pending_payments') }}</span>
      </div>
    </v-btn>
    <v-btn
      v-else-if="is_ontable_mylist && (is_colombian_customer || is_mexican_customer)"
      @click="goToCart()"
      color="cluvi2" class="pay-btn" x-small
      v-html="$t('order.pay_label')"
    />
    <v-btn
      v-if="
        showLangIconOrdered &&
        this.countProductsOrdered === 0 &&
        !(this.$route.name == 'MyOrder' && this.navMyOrder == 2)"
      @click="openShowLanguageSelectorModal()"
      color="cluvi2" fab x-small class="pay-btn"
      >
      <v-icon color="white">fa-light fa-globe</v-icon>
    </v-btn>
    <locale-switcher
      v-if="showLanguageSelector"
      :instance="instance"
      :flatOpenModal="flatOpenModal"
      @showLanguageSelectorModal="showLanguageSelectorModal"
    />
  </div>
</template>

<script>
import { mapMutations, mapState, mapGetters } from "vuex";
import { OnTableCart } from '@/services/OnTableCart';

export default {
  name: "HeaderCart",
  components: {
    LocaleSwitcher: () => import("../layout/LocaleSwitcher.vue")
  },
  data() {
    return {
      showTooltip: false,
      showLanguageSelector: false,
      flatOpenModal: false
    };
  },
  computed: {
    ...mapState('order', ["service", "otPurchaseId", "purchaseId", "taPurchaseId", "countProductsList"]),
    ...mapState('customer', ["supplier", "instance"]),
    ...mapState('ontable', ['countProductsOrdered', "navMyOrder", "productInCook"]),
    ...mapGetters('customer', ["is_ontable_checkout", "is_ontable_mylist", "is_ontable_basic", "has_cluvipay", "is_colombian_customer", "is_mexican_customer"]),
    ...mapGetters('order', ["is_take_away_service", "is_delivery_service","is_ontable_service","is_room_service"]),
    showLangIconOrdered: function() {
      if (this.instance?.langs?.length === 1 && this.instance?.langs[0] === this.instance?.language) return false;
      else if (this.instance?.langs?.length > 0 && this.countProductsOrdered === 0) return true;
      else return false;
    },
    validateIconCart: function() {
      return (
        (this.is_ontable_service && (this.otPurchaseId !== null || this.showLangIcon) && (this.is_ontable_mylist && !this.has_cluvipay)) ||
        (( this.is_delivery_service || this.is_take_away_service ) && (this.purchaseId !== null || this.taPurchaseId !== null))
      );
    },
    validateIconCallWaiter() {
      return (this.otPurchaseId !== null && this.is_ontable_checkout)
    },
    icon() {
      if(this.service === 'on_table') {
        if(this.is_ontable_mylist) return 'fa-light fa-heart';
        else if (this.is_ontable_checkout) return 'fa-light fa-hand-holding-dollar';
        else return 'fa-light fa-user-tie';
      } else if (this.is_delivery_service || this.is_take_away_service) return 'fa-light fa-cart-shopping';
      return '';
    },
    showBadge: function() {
      if(((this.is_ontable_service || this.is_room_service || this.service === 'delivery') && this.countProductsList > 0)) return true;
      else return false;
    },
    countBadge: function() {
      return this.countProductsList;
    },
    orderWithProducts: function () {
      return this.countProductsOrdered>0 || this.countProductsList>0
    },
    can_pay: function() {
      return ((this.is_ontable_checkout && this.orderWithProducts) ||
      ((this.is_ontable_mylist || this.is_ontable_basic) && this.has_cluvipay) && !(this.$route.name==='MyOrder' && this.navMyOrder === 2) &&!this.is_delivery_service);
    }
  },
  methods: {
    ...mapMutations('ontable', ['SetNavigatorMyOrder']),
    ...mapMutations('order', ['setTip', 'SetOtPurchaseId']),
    openShowLanguageSelectorModal() {
      this.flatOpenModal = true;
      this.showLanguageSelector = true;
    },
    showLanguageSelectorModal() {
      this.showLanguageSelector = false;
    },
    goToCart() {
      if(this.service === 'delivery' || this.service === 'take_away'){
        this.$router.push({
          name: "DeliveryCartInProgress",
          params: { supplier_id: this.supplier.slug }
        });
      };
      if(this.is_ontable_service) {
        if (this.showBadge || this.has_cluvipay) {
          this.SetNavigatorMyOrder(2);
          this.setTip({ include: 'YES', percent:10});
          if (this.$route.name !== 'MyOrder') {
            if((this.is_ontable_mylist || this.is_ontable_basic) && this.has_cluvipay && !this.otPurchaseId) {
              OnTableCart.createPurchaseByManualPayment(0).then(res =>  {
                if(res.data) {
                  this.SetOtPurchaseId(res.data.id)
                  this.goToMyOrder();
                };
              }).catch(err => console.error(err));
            }
            else this.goToMyOrder();
          }
        } else {
          if (!this.showTooltip && (this.is_ontable_checkout || this.can_pay)) {
            this.showTooltip = true;
            setTimeout(() => {
              this.showTooltip = false;
            },3000);
          };
        }
      }
    },
    goToMyOrder() {
      this.$router.push({
        name: "MyOrder",
        params: { supplier_id: this.supplier.slug, purchase_id: this.otPurchaseId }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.header-cart-view {
  display: flex;
  flex-direction: row;
}
.v-btn {
  text-transform: unset;
  white-space: normal;
}
.tooltip {
  width: 90px;
  background-color: #fff;
  color: #000;
  text-align: center;
  border-radius: 6px;
  padding: 5px 5px;
  position: absolute;
  z-index: 2000;
  top: 35px;
  left: -38px;
  font-size: 12px;
  font-family: "Poppins", sans-serif !important;
  text-align: left;
  opacity:0.8;
}
.tooltip::after {
  content: "";
  position: absolute;
  top: -15px;
  right: 15px;
  margin-left: -5px;
  border-width: 8px;
  border-style: solid;
  border-color:  transparent transparent white transparent;
}
.v-btn-toggle {
  flex-direction: column !important;
  width: 100%;
}
.v-card__text {
  padding: 0 !important;
}
.pay-btn {
  border-radius: 8px !important;
  margin: 0rem 0.5rem 0rem 0.5rem;
}
</style>
